'use client';
import * as React from 'react';

export const ModalPresentationContext = React.createContext(false);
